import Enums from "../components/enums";

class AddressSortingAndFiltering {
  static sortAndFilterAddresses(sortOrder, addressFilter, addresses) {
    return new Promise(function (resolve, reject) {
      let sortedAndFilteredAddresses = addresses.filter((a) => {
        let name = a.businessName ? a.businessName : a.name;

        if (!name) {
          name = "";
        }

        return (
          name.toUpperCase().includes(addressFilter.toUpperCase()) ||
          a.street.toUpperCase().includes(addressFilter.toUpperCase())
        );
      });

      if (sortOrder !== Enums.SortOrder.None) {
        var sortOrderNameFirst;
        var sortOrderNameSecond;

        sortedAndFilteredAddresses.sort((a, b) => {
          sortOrderNameFirst = (a.businessName || a.name).toUpperCase();
          sortOrderNameSecond = (b.businessName || b.name).toUpperCase();
          return sortOrderNameFirst.localeCompare(sortOrderNameSecond);
        });

        if (sortOrder === Enums.SortOrder.Descending) {
          sortedAndFilteredAddresses.reverse();
        }
      }
      resolve(sortedAndFilteredAddresses);
    });
  }
}

export default AddressSortingAndFiltering;
